import AppDashboard from '@js/components/account/dashboard/AppDashboard.vue'
import AppProfile from '@js/components/account/profile/AppProfile.vue'
import AppReceipt from './dashboard/AppReceipt.vue'

const accountComponents = [
  AppDashboard,
  AppProfile,
  AppReceipt,
]

export default accountComponents
